import { INewsItem } from '../../../reducers/news';
import NewsItem from './NewsItem';

interface INewsBlockProps {
  items: INewsItem[];
}

const NewsBlock = ({ items }: INewsBlockProps) => {
  return (
    <div className='news_mobile__content__news'>
      {items.map((item: INewsItem) => (
        <NewsItem key={item.id} card={item} />
      ))}
    </div>
  );
};

export default NewsBlock;
